module.exports = __webpack_public_path__ + "assets/12d424b37146928587dabe7716fd6c5f.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/volume.mp3
 ** module id = 230
 ** module chunks = 0
 **/